import styled from '../../../theme/styled-with-theme';

export const Table = styled('table')`
  border: 1px solid #f1f1f1;
  border-collapse: collapse;
  font-size: 14px;
  text-align: left;
  width: 100%;
`;

export const TableHeader = styled('th')`
  padding: 10px;
`;

export const Row = styled('tr')`
  border: 1px solid #f1f1;
`;

export const Cell = styled('td')`
  padding: 10px;
  border: 1px solid #f1f1f1;
`;
